<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ getTitle() }}</h3>
    </div>
  </div>
  <form class="form form-group-seperator-dashed" [formGroup]="pageGroupForm">
    <div class="navi-hover scroll card-body" [perfectScrollbar]="{ wheelPropagation: false }">
      <div class="form-group">
        <mat-form-field appearance="fill" class="mat-form-field-fluid">
          <mat-label>Name</mat-label>
          <input matInput required formControlName="name" />
          <mat-error *ngIf="isControlHasError('name', 'required')">
            Name is
            <strong>required</strong>
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="fill" class="mat-form-field-fluid">
          <mat-label>Pages</mat-label>
          <mat-chip-list #chipList required formControlName="pages">
            <mat-chip
              color="primary"
              selected
              (click)="$event.stopPropagation()"
              *ngFor="let p of selectedPages"
              (removed)="remove(p)"
            >
              {{ p.name }}
              <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
            <input
              matInput
              (click)="$event.stopPropagation()"
              placeholder="Select page..."
              [matChipInputFor]="chipList"
              #pagess
              formControlName="pages"
              required
              [matAutocomplete]="auto1"
            />
          </mat-chip-list>
          <mat-autocomplete
            #auto1="matAutocomplete"
            [displayWith]="pageFn"
            (optionSelected)="selected1($event)"
          >
            <mat-option
              *ngFor="let page of optionPages"
              [value]="page"
              [disabled]="isSelected(page)"
              (click)="$event.stopPropagation()"
            >
              <span> {{ page.name }} </span>
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="isControlHasError('pages', 'required')">
            Pages is
            <strong>required</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button (click)="close()" type="button" mat-raised-button matTooltip="Cancel">
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <button
            type="button"
            mat-raised-button
            color="primary"
            (click)="onSubmit()"
            matTooltip="Save"
          >
            <span>Save</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
